/**
 * 向 head 中添加 ld+json 脚本
 * @param {Object} data - ld+json 数据对象
 * @param {string} id - 唯一标识，用于后续删除
 */
export function addLdJsonToHead(data, id) {
  // 先移除已存在的同 id 脚本（避免重复）
  removeLdJsonFromHead(id);

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = id; // 增加唯一标识，方便删除
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

/**
 * 从 head 中移除指定 id 的 ld+json 脚本
 * @param {string} id - 脚本唯一标识
 */
export function removeLdJsonFromHead(id) {
  const existingScript = document.getElementById(id);
  if (existingScript) {
    document.head.removeChild(existingScript);
  }
}
